export default __webpack_public_path__ + "static/media/pdf.4340ae7b.png";